import { render, staticRenderFns } from "./cards-list-item-article-lot.vue?vue&type=template&id=6543e0ba&scoped=true&"
import script from "./cards-list-item-article-lot.vue?vue&type=script&lang=js&"
export * from "./cards-list-item-article-lot.vue?vue&type=script&lang=js&"
import style0 from "./cards-list-item-article-lot.vue?vue&type=style&index=0&id=6543e0ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6543e0ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
